module.exports = {"create_annually_inform":"Crear Informe Anual","date_range":"Rango de fechas","create":"Crear","annually_inform":"Informe Anual"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/AnuallSumary.json
// module id = 597
// module chunks = 1